import React from "react";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

export default function NotFound() {
  return (
    <>
      <SEO title="Page Not Found" description="The page you're looking for doesn't exist." path="/404" />
      <div className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden text-center">
        <div className="absolute inset-0 grid-bg radial-fade opacity-50" />
        <div className="relative">
          <p className="font-heading text-[120px] font-black leading-none text-gradient sm:text-[180px]">404</p>
          <h1 className="mt-4 font-heading text-2xl font-semibold text-white sm:text-3xl">This page took a wrong turn</h1>
          <p className="mx-auto mt-4 max-w-md text-slate-400">The page you're looking for doesn't exist or has been moved.</p>
          <Link to="/" className="btn-primary mt-8">Back to home</Link>
        </div>
      </div>
    </>
  );
}
